import React from 'react';
import classNames from 'classnames';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * NOTE: don't use this, it's deprecated. We're using bootstrap Button components instead
 *
 * @deprecated
 */

var CustomButton = React.createClass({
  render() {
    var { props } = this,
      { className, children, expand, active } = props;

    return (
      <button
        {...props}
        className={classNames('btn', className || '', {
          'btn-100': expand,
          active: active,
        })}
      >
        {children}
      </button>
    );
  },
});

CustomButton.Small = React.createClass({
  render() {
    var { props } = this,
      { className, children } = props;

    className = 'btn-sm ' + className;

    return (
      <CustomButton {...props} className={className}>
        {children}
      </CustomButton>
    );
  },
});

CustomButton.Large = React.createClass({
  render() {
    var { props } = this,
      { className, children } = props;

    className = 'btn-lg ' + className;

    return (
      <CustomButton {...props} className={className}>
        {children}
      </CustomButton>
    );
  },
});

export default CustomButton;
